"use client";

import { useLayoutEffect, useRef, useState } from "react";

const useOverflowBadges = (itemCount: number) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRefs = useRef<(HTMLDivElement | null)[]>([]);
  const overflowRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState<number>(itemCount);

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const recalculate = () => {
      const available = container.clientWidth;
      const overflowWidth = overflowRef.current?.offsetWidth || 0;
      let usedWidth = 0;
      let count = 0;

      for (let index = 0; index < itemCount; index += 1) {
        const itemWidth = measureRefs.current[index]?.offsetWidth || 0;
        const reserved = index === itemCount - 1 ? 0 : overflowWidth;
        if (usedWidth + itemWidth + reserved > available) break;
        usedWidth += itemWidth;
        count += 1;
      }

      setVisibleCount(count);
    };

    recalculate();
    const observer = new ResizeObserver(recalculate);
    observer.observe(container);
    return () => observer.disconnect();
  }, [itemCount]);

  return { containerRef, measureRefs, overflowRef, visibleCount };
};

export default useOverflowBadges;
